import {
  FaGithub,
  FaLinkedin,
  FaInstagram,
  FaStackOverflow,
} from "react-icons/fa";
import { Link } from "react-scroll";
import { SiCodewars, SiHackerrank, SiLeetcode } from "react-icons/si";

import "./Leftbar.css";
import {
  FULL_NAME,
  HEADLINE,
  POSITION,
  SECTIONS,
  SOCIAL_NETWORKS,
} from "../../data";

export default function Leftbar({ activeSection }) {
  const renderPersonalInfo = () => {
    return (
      <div className="personal-info-container">
        <h1 className="name">{FULL_NAME}</h1>
        <h2 className="position">{POSITION}</h2>
        <p className="headline">{HEADLINE}</p>
      </div>
    );
  };

  const renderSections = () => {
    const { ABOUT, EXPERIENCE, SKILLS, CERTIFICATIONS, PROJECTS } = SECTIONS;

    return (
      <div className="sections-container">
        <Link
          className={activeSection === ABOUT ? "section-focus" : "section"}
          to={ABOUT}
          spy={true}
          smooth={true}
          duration={600}
        >
          ABOUT
        </Link>
        <Link
          className={activeSection === EXPERIENCE ? "section-focus" : "section"}
          to={EXPERIENCE}
          spy={true}
          smooth={true}
          duration={600}
        >
          EXPERIENCE
        </Link>
        <Link
          className={activeSection === SKILLS ? "section-focus" : "section"}
          to={SKILLS}
          spy={true}
          smooth={true}
          duration={600}
        >
          SKILLS
        </Link>
        <Link
          className={
            activeSection === CERTIFICATIONS ? "section-focus" : "section"
          }
          to={CERTIFICATIONS}
          spy={true}
          smooth={true}
          duration={600}
        >
          CERTIFICATIONS
        </Link>
        <Link
          className={activeSection === PROJECTS ? "section-focus" : "section"}
          to={PROJECTS}
          spy={true}
          smooth={true}
          duration={600}
        >
          PROJECTS
        </Link>
      </div>
    );
  };

  const renderSocialNetworks = () => {
    const {
      GITHUB,
      LINKEDIN,
      INSTAGRAM,
      STACKOVERFLOW,
      LEETCODE,
      HACKERRANK,
      CODEWARS,
    } = SOCIAL_NETWORKS;

    return (
      <div className="social-networks-container">
        <a href={GITHUB} target="_blank" rel="noreferrer noopener">
          <FaGithub
            className="social-network"
            size={window.innerWidth <= 1024 ? 20 : 24}
          />
        </a>
        <a href={LINKEDIN} target="_blank" rel="noreferrer noopener">
          <FaLinkedin
            className="social-network"
            size={window.innerWidth <= 1024 ? 20 : 24}
          />
        </a>
        <a href={INSTAGRAM} target="_blank" rel="noreferrer noopener">
          <FaInstagram
            className="social-network"
            size={window.innerWidth <= 1024 ? 20 : 24}
          />
        </a>
        <a href={STACKOVERFLOW} target="_blank" rel="noreferrer noopener">
          <FaStackOverflow
            className="social-network"
            size={window.innerWidth <= 1024 ? 20 : 24}
          />
        </a>
        <a href={LEETCODE} target="_blank" rel="noreferrer noopener">
          <SiLeetcode
            className="social-network"
            size={window.innerWidth <= 1024 ? 20 : 24}
          />
        </a>
        <a href={HACKERRANK} target="_blank" rel="noreferrer noopener">
          <SiHackerrank
            className="social-network"
            size={window.innerWidth <= 1024 ? 20 : 24}
          />
        </a>
        <a href={CODEWARS} target="_blank" rel="noreferrer noopener">
          <SiCodewars
            className="social-network"
            size={window.innerWidth <= 1024 ? 20 : 24}
          />
        </a>
      </div>
    );
  };

  return (
    <div className="leftbar">
      {renderPersonalInfo()}
      {renderSections()}
      {renderSocialNetworks()}
    </div>
  );
}
